// Define the Konsole interface
interface Konsole {
    log: (...args: any[]) => void;
    error: (...args: any[]) => void;
    info: (...args: any[]) => void;
    warn: (...args: any[]) => void;
}

const isConsole = false;
const Konsole: Konsole = {


    log: (...args: any[]) => {
        if (isConsole) {
            console.log(...args);  
        }
    },

    error: (...args: any[]) => {
        if (isConsole) {
            console.error(args); 
        }
    },

    info: (...args: any[]) => {
        if (isConsole) {
            console.info(args);  
        }
    },

    warn: (...args: any[]) => {
        if (isConsole) {
            console.warn(args);
        }
    }
};

// Export the Konsole object as the default export
export default Konsole;
